import { Grid } from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles'
import React, { ReactNode } from 'react'

import { Theme } from '../../../lib/theming/Theme'
import ButtonItem from './ButtonItem'
import { ButtonItemConfig } from './ButtonItemConfig'

type RefinementNavBarProps = {
  items: ButtonItemConfig[]
  settingsItem?: ReactNode
}

const useStyles = makeStyles<Theme>(({ palette, spacing, breakpoints }) => ({
  button: {
    '&:hover': {
      color: palette.secondary.main,
    },
    borderRadius: '2.5rem',
    padding: spacing(0.5),
    [breakpoints.up('md')]: {
      marginRight: spacing(0.5),
      padding: spacing(1.25, 3.5),
    },
  },
  buttonActive: {
    '&:hover': {
      backgroundColor: palette.secondary.main,
      color: palette.common.white,
    },
    backgroundColor: palette.secondary.main,
    color: palette.common.white,
  },
  root: {
    justifyContent: 'space-between',
    padding: spacing(2, 0, 0),
    [breakpoints.up('md')]: {
      justifyContent: 'flex-start',
      padding: spacing(3),
    },
  },
  timezone: {
    alignSelf: 'center',
    marginLeft: 'auto',
    padding: spacing(0.5),
    [breakpoints.up('md')]: {
      width: 'auto',
    },
  },
}))

const RefinementNavBar = ({ items, settingsItem }: RefinementNavBarProps) => {
  const classes = useStyles()

  return (
    <Grid container item className={classes.root}>
      {items.map(item => (
        <ButtonItem
          key={item.id}
          classes={{ button: classes.button, buttonActive: classes.buttonActive }}
          item={item}
        />
      ))}
      {settingsItem && (
        <Grid container item classes={{ root: classes.timezone }} md="auto" spacing={1} xs={12}>
          {settingsItem}
        </Grid>
      )}
    </Grid>
  )
}

export default RefinementNavBar
